import React, { useContext } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import SpecDetailTitle from "./SpecDetailTitle";
import ActionDetailLink from "./ActionDetailLink";
import {
  PORevisionContext,
  RevisionReferenceContext,
  LabeledTextContext,
} from "../../../withPORevision";

const StyledSpecDetailDescription = styled.div`
  padding-bottom: 12px;
`;

const Description = styled.div`
  margin-top: 12px;
  font-size: 12px;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.54);
  text-overflow: ellipsis;
  position: relative;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  clear: both;
  ${({ isUpdated }) =>
    isUpdated &&
    `
  font-style: italic;
  font-weight: 600;
  color: #000000;
  `}
  &:after {
    ${({ isUpdated }) =>
      isUpdated &&
      `
    position: absolute;
    content: "\\25CF";
    font-size: 10px;
    top: -8px;
    left: -8px;
    overflow: visible;
    color: #ff9100;
  `}
  }

  /* Estilos para el contenido HTML del editor */
  & * {
    max-width: 100%;
  }

  & p {
    margin: 0 0 8px 0;
    line-height: 1.4;
  }

  & ul,
  & ol {
    margin: 8px 0;
    padding-left: 20px;
  }

  & strong,
  & b {
    font-weight: 600;
  }

  & em,
  & i {
    font-style: italic;
  }

  & a {
    color: #3f51b5;
    text-decoration: underline;
  }

  & img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  & table {
    border-collapse: collapse;
    width: 100%;
    margin: 8px 0;
  }

  & table td,
  & table th {
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 4px 8px;
  }

  & h1,
  & h2,
  & h3,
  & h4,
  & h5,
  & h6 {
    margin: 12px 0 4px 0;
    font-weight: 600;
    line-height: 1.1;
  }
`;

const SpecDetailDescription = props => {
  const { title, description, id } = props.specDetail;
  const { isUpdated } = useContext(PORevisionContext);
  const { reference } = useContext(RevisionReferenceContext);
  const isLabeled = useContext(LabeledTextContext);
  const detailReference = `${reference}.${id}`;
  return (
    <StyledSpecDetailDescription>
      <SpecDetailTitle isUpdated={isUpdated(detailReference, "title")}>
        {title ? title : "-"}
      </SpecDetailTitle>
      {description && (
        <Description
          isUpdated={isUpdated(detailReference, "description")}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
      <ActionDetailLink
        visible={!description && !isLabeled}
        specDetail={props.specDetail}
        type="Description"
      />
    </StyledSpecDetailDescription>
  );
};

SpecDetailDescription.propTypes = {
  specDetail: PropTypes.object,
};

export default SpecDetailDescription;
